import React from 'react';
import createForm from "./Form";
import PartnerForm from "./partnerForm";

class FranchisePartnerForm extends React.Component {

    render() {
        return <PartnerForm {...this.props} />;
    }
}

export default createForm(FranchisePartnerForm);
